require('./broadcastStatusController');

"use strict";

angular.module('app.broadcastStatus', [
  'app.broadcastStatus.broadcastStatusController',
])
    .config([
      '$stateProvider',
      function ($stateProvider) {
        $stateProvider.state('app.broadcastStatus', {
          url: '/status',
          templateUrl: 'components/broadcastStatus/broadcastStatusView.html',
          controller: 'app.broadcastStatus.broadcastStatusController',
          title: 'Broadcast Status'
        })
      }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/broadcastStatus/broadcastStatus.js